import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HIS_MENU_TITLE, HIS_SECTIONS } from '../config/hisSections';
import { canAccessHisReport } from '../utils/hisReportAccess';

const SECTION_ICONS: Record<string, React.ReactNode> = {
  reports: (
    <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
  ),
  voids: (
    <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
  ),
  'online-conversion': (
    <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
};

const AdminHisHub: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      navigate('/admin/login');
      return;
    }
    if (!canAccessHisReport()) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  return (
    <div className="w-full space-y-6">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-l from-indigo-600 via-indigo-700 to-slate-800 px-5 py-4 text-white shadow-lg shadow-indigo-900/20 sm:px-6">
        <div
          className="pointer-events-none absolute -left-16 -top-16 h-48 w-48 rounded-full bg-white/10 blur-2xl"
          aria-hidden
        />
        <p className="text-xs font-medium uppercase tracking-wider text-indigo-200">سیستم بیمارستانی</p>
        <h1 className="mt-0.5 text-xl font-bold tracking-tight sm:text-2xl">{HIS_MENU_TITLE}</h1>
        <p className="mt-1 text-xs text-indigo-100/90">بخش مورد نظر را انتخاب کنید</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {HIS_SECTIONS.map((section) => (
          <button
            key={section.id}
            type="button"
            onClick={() => navigate(section.path)}
            className="group rounded-2xl border border-slate-200/80 bg-white p-5 text-right shadow-sm transition hover:border-indigo-200 hover:shadow-md hover:shadow-indigo-100/50"
          >
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 transition group-hover:bg-indigo-100">
              {SECTION_ICONS[section.id]}
            </div>
            <h2 className="text-base font-bold text-slate-900">{section.title}</h2>
            <p className="mt-1.5 text-sm leading-relaxed text-slate-500">{section.description}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-indigo-600 opacity-0 transition group-hover:opacity-100">
              ورود
              <svg className="h-3.5 w-3.5 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminHisHub;
